import useActionReducer from '@admin/hooks/use_action_reducer'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import Drive from './drive'
import React from 'react'

const DriveContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'attachments_drive',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Drive { ...mergedProps } />

}

DriveContainer.propTypes = {}

export default DriveContainer